// extracted by mini-css-extract-plugin
module.exports = {"h5button":"gN","h5Button":"gN","button":"gO","block":"gP","btnDefault":"gQ","disable":"gR","btnPrimary":"gS"};